import { AppConstants } from '.'

const baseHeader = {
    'Content-Type': 'application/json',
}

// const multipartFormHeader = {
//     'Content-Type': 'multipart/form-data',
// }

const apiConfig = {
    restaurant: {
        getInfo: {
            path: 'v1/restaurant/detail',
            method: 'GET',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
            noAuth: true,
        },
        requestTable: {
            path: 'v1/order/request_table_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
        verifyTable: {
            path: 'v1/order/verify_table_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
        retryRequestTable: {
            path: 'v1/order/table_retry',
            method: 'GET',
            headers: baseHeader,
        },
        checkTableStatus: {
            path: 'v1/order/check_table_status_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
    },

    foodGroup: {
        list: {
            path: 'v1/group_food/list_by_restaurant',
            method: 'GET',
            headers: baseHeader,
            requireTenantId: true,
        },
    },

    food: {
        listFood: {
            path: 'v1/food/list_by_restaurant',
            method: 'GET',
            headers: baseHeader,
            requireTenantId: true,
        },

        listByGroup: {
            path: 'v1/food/list_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
        search: {
            path: 'v1/food/autocomple_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
        getOne: {
            path: 'v1/food/get_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
        orderFood: {
            path: 'v1/order/add_food_table_by_qrcode',
            method: 'POST',
            headers: baseHeader,
        },
        retryOrder: {
            path: 'v1/order/table_retry_food_order',
            method: 'GET',
            headers: baseHeader,
        },
        getFoodState: {
            path: 'v1/order/verify_food_state_by_qrcode',
            method: 'GET',
            headers: baseHeader,
        },
    },

    file: {
        download: {
            path: 'v1/file/download',
        },
    },

    account: {
        register: {
            path: 'v1/customer/register',
            method: 'POST',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        login: {
            path: 'api/token',
            method: 'POST',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
            noAuth: true,
        },
        profile: {
            path: 'v1/customer/profile',
            method: 'GET',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        updateProfile: {
            path: 'v1/customer/update_profile',
            method: 'PUT',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        updatePassword: {
            path: 'v1/customer/update',
            method: 'PUT',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        forgotPassword: {
            path: 'v1/account/request_forget_password',
            method: 'POST',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        resetPassword: {
            path: 'v1/account/forget_password',
            method: 'POST',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
        updateAddress: {
            path: 'v1/customer/update_address',
            method: 'PUT',
            headers: baseHeader,
            domain: AppConstants.apiRootUrl,
        },
    },
    order: {
        verifyTable: {
            path: 'v1/order/scan_qrcode_verify',
            method: 'POST',
            headers: baseHeader,
            requireTenantId: true,
        },
        verifyQRCode: {
            path: 'v1/order/verify_tablet_qrcode',
            method: 'GET',
            headers: baseHeader,
            requireTenantId: true,
        },
        addToCart: {
            path: 'v1/order/add_food_to_table',
            method: 'POST',
            headers: baseHeader,
            noAuth: true,
        },
        addToCartTakeAGo: {
            path: 'v1/order/tablet_qrcode_add_food',
            method: 'POST',
            headers: baseHeader,
            noAuth: true,
        },
        requestPayment: {
            path: 'v1/order/customer_request_payment',
            method: 'POST',
            headers: baseHeader,
            noAuth: true,
            requireTenantId: true,
        },
        searchLocation: {
            path: `https://maps.googleapis.com/maps/api/geocode/json`,
            method: 'GET',
            headers: {},
            noAuth: true,
            ignoreClientType: true,
        },
        calcDistance: {
            path: `map-auto-complete/maps/api/distancematrix/json`,
            method: 'GET',
            headers: {},
            noAuth: true,
            ignoreClientType: true,
        },
        saveOrder: {
            path: 'v1/order/save_order',
            method: 'POST',
            headers: baseHeader,
            requireTenantId: true,
        },
        orderDetails: {
            path: 'v1/order/get_order_by_code',
            method: 'GET',
            headers: baseHeader,
            requireTenantId: true,
        },
        ordersQRCode: {
            path: 'v1/order/get_order_by_qrcode',
            method: 'GET',
            headers: baseHeader,
            noAuth: true,
        },
        closeNotiDoneOrder: {
            path: 'v1/order/tablet_qrcode_customer_update',
            method: 'PUT',
            headers: baseHeader,
            noAuth: true,
        },
        orderInfo: {
            path: 'v1/order/get_order_by_code',
            method: 'GET',
            headers: baseHeader,
            noAuth: true,
            requireTenantId: true,
        },
        payOther: {
            path: 'v1/order/change_type_payment',
            method: 'PUT',
            headers: baseHeader,
            noAuth: true,
        },
        answerQuestion: {
            path: 'v1/order/update_question',
            method: 'POST',
            headers: baseHeader,
        }
    },
    voucher: {
        getByCode: {
            path: 'v1/voucher/get-by-code/:code',
            method: 'GET',
            headers: baseHeader,
            requireTenantId: true,
        },
    },
}

export default apiConfig
